export default __webpack_public_path__ + "static/media/empty-reports-switch.d771f160.svg";